import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5da8256"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-mycells" }
const _hoisted_2 = {
  key: 0,
  class: "nge-mycells-note"
}
const _hoisted_3 = {
  key: 1,
  class: "nge-mycells-note nge-mycells-note--bad"
}
const _hoisted_4 = {
  key: 2,
  class: "nge-mycells-note"
}
const _hoisted_5 = { class: "nge-mycells-head" }
const _hoisted_6 = { class: "nge-mycells-ds" }
const _hoisted_7 = {
  key: 0,
  class: "nge-mycells-here"
}
const _hoisted_8 = { class: "nge-mycells-count" }
const _hoisted_9 = ["onClick", "title"]
const _hoisted_10 = { class: "nge-mycells-id" }
const _hoisted_11 = { class: "nge-mycells-status" }
const _hoisted_12 = { class: "nge-mycells-when" }
const _hoisted_13 = ["disabled", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading cells…"))
      : ($setup.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.error), 1 /* TEXT */))
        : (!$setup.ordered.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "No cells yet. Claim one in the Cell Library to start."))
          : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ordered, (g) => {
      return (_openBlock(), _createElementBlock("section", {
        key: g.dataset,
        class: "nge-mycells-group"
      }, [
        _createElementVNode("header", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString($setup.label(g.dataset)), 1 /* TEXT */),
          (g.dataset === $setup.current)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "current"))
            : _createCommentVNode("v-if", true),
          _createElementVNode("span", _hoisted_8, _toDisplayString(g.rows.length) + _toDisplayString(g.serverDone ? '' : '+'), 1 /* TEXT */)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.rows.slice(0, g.shown), (r) => {
          return (_openBlock(), _createElementBlock("button", {
            key: r.key,
            class: "nge-mycells-row",
            onClick: $event => ($setup.jump(g, r)),
            title: `Jump to ${r.segId}`
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["nge-mycells-pip", 'nge-mycells-pip--' + r.status])
            }, _toDisplayString(r.status === 'completed' ? '✓' : r.status === 'claimed' ? '●' : '○'), 3 /* TEXT, CLASS */),
            _createElementVNode("span", _hoisted_10, _toDisplayString($setup.shortId(r.segId)), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_11, _toDisplayString(r.status === 'completed' ? 'Completed' : r.status === 'claimed' ? 'Claimed' : (r.cellType || 'Viewed')), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_12, _toDisplayString($setup.ago(r.when)), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_9))
        }), 128 /* KEYED_FRAGMENT */)),
        (g.shown < g.rows.length || !g.serverDone)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "nge-mycells-more",
              disabled: g.loading,
              onClick: $event => ($setup.showMore(g))
            }, _toDisplayString(g.loading ? 'Loading…' : 'Show more'), 9 /* TEXT, PROPS */, _hoisted_13))
          : _createCommentVNode("v-if", true)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}